import React, { type ReactNode } from 'react';
import styled from 'styled-components';

// Layout components
const LayoutContainer = styled.div`
  display: flex;
  gap: 24px;
  width: 100%;
  height: 100%;
  overflow: hidden;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const MainContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow-y: auto;
  padding-right: 16px;
`;

const Sidebar = styled.div`
  width: 300px;
  overflow-y: auto;
  padding-right: 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

const ContentWrapper = styled.div`
  padding: 24px;
  height: calc(100vh - 64px); /* Adjust for header height */
  overflow: hidden;
`;

// Mobile metadata display (only shown on mobile)
const MobileMetadata = styled.div`
  display: none;
  margin-bottom: 16px;

  @media (max-width: 768px) {
    display: block;
  }
`;

interface AgentRunLayoutProps {
  mainContent: ReactNode;
  sidebarContent: ReactNode;
}

const AgentRunLayout: React.FC<AgentRunLayoutProps> = ({
  mainContent,
  sidebarContent,
}) => {
  return (
    <ContentWrapper>
      <LayoutContainer>
        <MainContent>
          {/* Mobile-only metadata display */}
          <MobileMetadata>{sidebarContent}</MobileMetadata>
          {mainContent}
        </MainContent>

        <Sidebar>
          {/* Desktop-only sidebar - hidden on mobile */}
          {sidebarContent}
        </Sidebar>
      </LayoutContainer>
    </ContentWrapper>
  );
};

export default AgentRunLayout;
export { ContentWrapper, MainContent, Sidebar, MobileMetadata };
